import axios from '@/api/axios'

const getSportClubs = () => {
    return axios.get(`/sports-clubs`)
}

const getSportClubsMore = (params) => {
  return axios.get(`/sports-clubs`, {params})
}

const addSportClubs = clubs => {
    return axios.post(`/sports-clubs`, clubs)
}

const updateSportClubs = club => {
    return axios.put(`/sports-clubs/${club.id}`, club)
}

const getSportClub = id => {
    return axios.get(`/sports-clubs/${id}`)
}

const deleteSportClub = id => {
    return axios.delete(`/sports-clubs/${id}`)
}

export default {
    getSportClubs,
    addSportClubs,
    getSportClub,
    updateSportClubs,
    deleteSportClub,
  getSportClubsMore
}
